import { IconArrowLeft, IconArrowRight } from 'components/Icons';
import { IconButton } from 'components/Input/IconButton';

import { NavigationProps } from './types';
import { Arrow, NavigationContainer } from './styles';

export function Navigation({ onNextClick, onPrevClick }: NavigationProps) {
  return (
    <NavigationContainer id='carousel-navigation'>
      <div id='left-arrow'>
        <IconButton
          priority='secondary'
          size='xs'
          onClick={onPrevClick}
          id='carousel-navigation-prev-button'
        >
          <Arrow>
            <IconArrowLeft fontSize='1rem' />
          </Arrow>
        </IconButton>
      </div>
      <div id='right-arrow'>
        <IconButton
          priority='secondary'
          size='xs'
          onClick={onNextClick}
          id='carousel-navigation-next-button'
        >
          <Arrow>
            <IconArrowRight fontSize='1rem' />
          </Arrow>
        </IconButton>
      </div>
    </NavigationContainer>
  );
}
